<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Edit Announcement</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="notification.name">
          </div>
          <div class="form-group">
            <label for="txtExtension">Extension</label>
            <input type="text" class="form-control" id="txtExtension" v-model="notification.extension">
            <small class="form-text text-muted">Not required, but can only play from web interface if left at 9. If inputted, must keep leading 9 and follow with 3 numbers. Example: 9001</small>
          </div>
          <div class="form-group">
            <label for="ddlZone">Zone</label>
            <v-select
              id="ddlZone"
              v-model="notification.zone"
              :options="zones_for_drop_down"
              placeholder="Select.."></v-select>
          </div>
          <div v-if="notification.sound_type_id === 1">
            <SoundDropDownAndPreview tag="announcement" v-model="notification.sound"></SoundDropDownAndPreview>
          </div>
          <div v-else-if="[2,3,4].includes(notification.sound_type_id)">
            <label for="ddlPlaylist">Playlist</label>
            <select class="form-control" id="ddlPlaylist" v-model="notification.playlist_id">
              <option value="0">Select..</option>
              <option v-for="playlist in filtered_playlists" :key="playlist.playlist_id" v-bind:value="playlist.playlist_id">
                {{ playlist.name }}
              </option>
            </select>
            <br>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" >Submit</button>
          <router-link :to="{ name: 'Notifications' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import SoundDropDownAndPreview from '../../components/SoundDropDownAndPreview'

export default {
  props: [
    'notification_id'
  ],
  components: { vSelect, SoundDropDownAndPreview },
  computed: {
    ...mapGetters({
      notification: 'singleNotification',
      sound_types: 'allSoundTypes',
      playlists: 'allPlaylists',
      zones_for_drop_down: 'allZonesForDropdown',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_playlists: function () {
      return this.playlists.filter(playlist => playlist.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getNotification', this.notification_id)
    this.$store.dispatch('getZones')
    this.$store.dispatch('getSoundTypes')
    this.$store.dispatch('getPlaylists')
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditNotification', this.notification)
    }
  }
}
</script>

<style scoped>

</style>
